import AppManagerClient from '../../api/AppManagerClient';
import { IManagingAppPoolsInstance } from '../../api/models';
import React, { useEffect, useState } from 'react';
import { AppPoolsServerManagementView } from './AppPoolsServerManagementView';
import { Stack } from 'react-bootstrap';
import { AppPoolsEnvironmentComparison } from '../Comparison/AppPoolsEnvironmentComparison';
import { AccordionWrapper } from '../UIExtentions/Accordion';

export const AppPoolsServerManagement = (props: any) => {
    const [serverApps, setServerApps] = useState(Array<IManagingAppPoolsInstance>());
    const [isLoading, setLoadingStatus] = useState(true);
    const [errorMessage, setErrorMessage] = useState('');
    const applicationName = props.applicationName;

    const getServers = async (appName: string) => {
        try {
            const serversResult = await AppManagerClient.getAppPoolsForManaging(appName);
            setServerApps(serversResult);
        } catch (err: any) {
            setErrorMessage(err.message);
        } finally {
            setLoadingStatus(false);
        }
    };

    useEffect(() => {
        getServers(applicationName);
    }, [applicationName]);

    return (
        <Stack gap={3}>
            <AccordionWrapper
                fitToSize={true}
                headerIcon="fa-code-compare"
                headerText="Environment Comparison"
                objectName={applicationName}
                isLoading={props.isLoading}
                errorMessage={props.errorMessage}
            >
                <AppPoolsEnvironmentComparison data={serverApps} />
            </AccordionWrapper>

            <AppPoolsServerManagementView
                serverApps={serverApps}
                userPrincipal={props.userPrincipal}
                isLoading={isLoading}
                errorMessage={errorMessage}
                isDataNotFound={serverApps.length === 0}
                applicationName={applicationName}
            />
        </Stack>
    );
};
